// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectedLocationText_root__2JzFm","text":"SelectedLocationText_text__1hfP6","delete":"SelectedLocationText_delete__3HTEj"};